
export const MAX_LETTERS = 5;

export enum CheckedLetter {
    WrongSpot,
    Incorrect,
    Correct
}


// Counts the letters in a word, returns a map of letter to count
export const countLetters = (word: string[]) => {
    const letterCounts = new Map<string, number>();

    for(let i=0; i < word.length; i++){
        const letter = word[i];
        // if this letter isn't in count object, store a new letter
        const count = letterCounts.get(letter)
        if (count) {
        letterCounts.set(letter, count+ 1);
        } else {
        letterCounts.set(letter, 1);
        }
    }
    return letterCounts;
}


// CheckedLetter[] == Array<CheckedLetter>;

export function checkWordGuess(guess: string[], answer: string[]): CheckedLetter[] {
    const checkedLetters: CheckedLetter[] = new Array(MAX_LETTERS);
    const answerLetterCount = countLetters(answer);

    const decrementCount = (letter: string) => {
        // console.log("decrementCount", answerLetterCount, letter)
        let c = answerLetterCount.get(letter)
        if (c) {
            c = c-1
            if (c == 0) {
                answerLetterCount.delete(letter)
            } else {
                answerLetterCount.set(letter, c);
            }
        } else {
            console.log("ERROR decrementCount");
        }
    }

    for (let i=0; i<MAX_LETTERS; i++) {
        if (guess[i] == answer[i]) {
            decrementCount(guess[i])
            checkedLetters[i] = CheckedLetter.Correct;
        }
    }

    for (let i=0; i<MAX_LETTERS; i++) {
        if (checkedLetters[i] == CheckedLetter.Correct) {
            continue;
        } else if (guess[i] != answer[i] && answerLetterCount.has(guess[i])) {
            decrementCount(guess[i])
            checkedLetters[i] = CheckedLetter.WrongSpot;
        } else if (guess[i] != answer[i]) {
            checkedLetters[i] = CheckedLetter.Incorrect;
        } else {
            console.log("ERROR in checkWordGuess in utils")
        }
    }

    return checkedLetters;
}

// export function makeUTCDate() {
//     const d = new Date();
//     return d.setTime(d.getTime());
//     // return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()));
// }
